import type { FC } from 'react'

import { Emoji } from 'emoji-picker-react'

type ReactionKey = 'cry' | 'kiss' | 'like' | 'love' | 'sad' | 'smile'

type ReactionBucket = {
  count?: number | string
}

type Reactions = Record<string, ReactionBucket>

const EMOJI_UNIFIED_BY_KEY: Record<ReactionKey, string> = {
  cry: '1f972',
  kiss: '1f618',
  like: '1f44d',
  love: '2764-fe0f',
  sad: '1f614',
  smile: '1f606'
}

const toEntries = (reactions: unknown) => {
  if (!reactions || typeof reactions !== 'object') return []

  const obj = reactions as Reactions

  return Object.keys(obj)
    .map((k) => {
      const count = Number(obj[k]?.count ?? 0)
      const unified = (EMOJI_UNIFIED_BY_KEY as Record<string, string>)[k] ?? ''
      return { key: k, count, unified }
    })
    .filter((r) => r.count > 0 && r.unified)
}

type Props = {
  reactions: unknown
  size?: number
  containerClassName: string
  reactionClassName: string
}

const MessageReactions: FC<Props> = ({
  reactions,
  size = 14,
  containerClassName,
  reactionClassName
}) => {
  const entries = toEntries(reactions)
  if (entries.length === 0) return null

  return (
    <div className={containerClassName}>
      {entries.map(({ key, count, unified }) => (
        <div key={key} className={reactionClassName}>
          <Emoji unified={unified} size={size} />
          <div>{count}</div>
        </div>
      ))}
    </div>
  )
}

export default MessageReactions
